export function resolveLocalTaskImportance(
  taskIds: string[],
  originalTaskImportance: Record<string, "OPTIONAL" | "REQUIRED">,
  taskImportanceChanges: Record<string, "OPTIONAL" | "REQUIRED" | null>
) {
  return taskIds.flatMap((taskId) => {
    const newImportance =
      taskImportanceChanges[taskId] === null
        ? null
        : (taskImportanceChanges[taskId] ?? originalTaskImportance[taskId]);

    if (!newImportance) {
      return [];
    }
    return [
      {
        taskId,
        importance: newImportance,
      },
    ];
  });
}
